import { ref } from "vue";
import apiClient from "@/services/apiClient";

// Singleton state — shared across all callers so openCrmModal() in the page
// opens the modal rendered by HomeCrmModal.
const showCrmModal = ref(false);
const crmMessage = ref("");
const crmError = ref(false);
const crmSent = ref(false);
const crmSending = ref(false);

/** Stato e azioni della modale "Assistenza sul Customer Portal" (richiesta CRM). */
export function useCrmRequest() {

  const setBodyOverflow = (active) => {
    document.getElementsByTagName("body")[0].classList.toggle("overflow", active);
  };

  const openCrmModal = () => {
    window.scrollTo(0, 0);
    crmMessage.value = "";
    crmError.value = false;
    showCrmModal.value = true;
    setBodyOverflow(true);
  };

  const closeCrmModal = (sent = false) => {
    window.scrollTo(0, 0);
    showCrmModal.value = false;
    setBodyOverflow(false);
    if (sent) {
      crmSent.value = true;
      setTimeout(() => {
        crmSent.value = false;
      }, 3000);
    }
  };

  const sendCrmMessage = async () => {
    crmError.value = false;
    if (crmMessage.value === "") {
      return;
    }
    crmSending.value = true;
    try {
      const response = await apiClient.post(
        "tickets/v1/crm-ticket",
        { message: crmMessage.value },
        { headers: { "Content-Type": " multipart/form-data" } }
      );
      if (response.data.success == "reply sent") {
        closeCrmModal(true);
      } else {
        crmError.value = true;
      }
    } catch (err) {
      console.log(err);
    } finally {
      crmSending.value = false;
    }
  };

  return {
    showCrmModal,
    crmMessage,
    crmError,
    crmSent,
    crmSending,
    openCrmModal,
    closeCrmModal,
    sendCrmMessage,
  };
}
